import {Box, Container, styled} from '@mui/material';

export const CarouselListWrapperContainer = styled(Container)<{isReactNativeView?: boolean}>(
  ({theme, isReactNativeView}) => ({
    position: 'relative',
    marginBottom: '20px',
    padding: isReactNativeView ? theme.spacing(0, 1, 0) : theme.spacing(2)
  })
);

export const CarouselListInnerWrapper = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column'
}));

export const CarouselListTitleContainer = styled(Box)(({theme}) => ({
  display: 'flex',
  paddingBottom: theme.spacing(2),
  alignItems: 'center',
  justifyContent: 'space-between'
}));

export const SeeAllTextContainer = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',
  flexShrink: 0
}));

export const SeeAllText = styled(Box)(({theme}) => ({
  display: 'flex',
  color: theme.palette.grey[900],
  fontWeight: theme.typography.h1.fontWeight,
  padding: theme.spacing(0.5, 1, 0),
  fontSize: theme.spacing(2),
  lineHeight: theme.spacing(3.2),
  '&.revampInPDPpage': {
    fontWeight: 'normal',
    paddingTop: 0,
    [theme.breakpoints.down('sm')]: {
      fontSize: theme.spacing(2)
    }
  },
  [theme.breakpoints.down('tablet')]: {
    fontSize: theme.spacing(1.75),
    lineHeight: theme.spacing(2.8)
  }
}));

export const CarouselListBannerContainer = styled(Box)(({theme}) => ({
  margin: 0,
  marginBottom: theme.spacing(3),
  [theme.breakpoints.down('sm')]: {
    marginBottom: theme.spacing(2)
  }
}));

export const TitleIconHolder = styled(Box)(({theme}) => ({
  padding: theme.spacing(0.5),
  backgroundColor: theme.palette.common.mds_global_color_red,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: theme.shape.borderRadius,
  width: theme.spacing(2),
  height: theme.spacing(2),
  marginRight: theme.spacing(1)
}));

export const TitleText = styled(Box)(({theme}) => ({
  flexGrow: 1,
  fontSize: theme.spacing(2.25),
  fontWeight: theme.typography.h1.fontWeight,
  color: theme.palette.grey[900],
  lineHeight: theme.spacing(3.6),
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  textAlign: 'left',
  '&.searchBoxCarousel': {
    fontSize: '16px'
    // padding: '0 0 0 14px'
  },
  [theme.breakpoints.down('tablet')]: {
    fontSize: theme.spacing(2),
    lineHeight: theme.spacing(3.2)
  }
}));

export const CarouselListContent = styled(Box)(() => ({
  display: 'block'
}));

export const CarouselListWrapperContent = styled(Box)(() => ({
  display: 'flex',
  textAlign: 'left'
}));

export const TabContainer = styled(Box)(({theme}) => ({
  paddingBottom: theme.spacing(3),
  [theme.breakpoints.down('sm')]: {
    paddingBottom: theme.spacing(2)
  }
}));
